export default {
      id: "sensors__battery-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#sensors__battery",
      toString: function () {
        return this.url;
      }
    }